import { useGetReportsConfigQuery } from "services/scheduledReports";
import { configOutcome } from "utils/reportErrors";

// The reports configuration as one of its outcomes: "loading", "available", "notAvailable", "paused"
// (a stopped service) or "error". Never defaults to available before it loads, and never refetches on
// focus: the navbar reads it on every page, cached.
const useScheduledReportsConfig = ({ skip = false } = {}) => {
  const token = window.localStorage.getItem("token");
  return configOutcome(useGetReportsConfigQuery({ token }, { skip: skip || !token }));
};

export default useScheduledReportsConfig;
